import {
  anInsight,
  anInsightComment,
  aUser,
  InsightComment,
  mockInsightCommentsQueryOperationQuery,
} from '__generated__';

export const getInsightCommentsQuery_create = (
  comment: Partial<InsightComment>
) =>
  mockInsightCommentsQueryOperationQuery((_req, res, ctx) => {
    const comments = anInsight().comments;
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        insight: anInsight({
          comments: [
            ...comments,
            {
              ...anInsightComment(),
              id: '3',
              // Comments have author aliased as user
              // @ts-ignore
              user: aUser(),
              ...comment,
            },
          ],
        }),
      })
    );
  });

export const handlers = [
  mockInsightCommentsQueryOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        insight: anInsight(),
      })
    );
  }),
];
